// Exact backend messages sent when IPQS (fraud/VPN/geo) checks block a
// request on the login, signup, and increase-clicks APIs. When a response's
// message matches one of these exactly, it's replaced with a heading +
// description formatted string (heading\ndescription) that the snackbar
// components render as two lines via `white-space: pre-line`.

export const IPQS_VPN_MESSAGE =
  "We couldn't complete your login. It looks like you're using a VPN or proxy service. To help keep your account secure, please disable it and try signing in again. If you continue having trouble, contact support.";

export const IPQS_FRAUD_SCORE_MESSAGE =
  "Something went wrong. We're unable to process your request at this time. Our security systems have flagged unusual activity associated with your connection. If you believe this is an error, please contact support.";

export const IPQS_COUNTRY_MISMATCH_MESSAGE =
  "We couldn't verify your location. It looks like you're signing in from a different country than usual. To keep your account secure, we've paused this login. If this is really you, please contact support or try again from your usual location.";

const IPQS_TOAST_MESSAGES: Record<string, string> = {
  [IPQS_VPN_MESSAGE]:
    "We couldn't complete your login\nIt looks like you're using a VPN or proxy service. To help keep your account secure, please disable it and try signing in again. If you continue having trouble, contact support.",
  [IPQS_FRAUD_SCORE_MESSAGE]:
    "Something went wrong\nWe're unable to process your request at this time. Our security systems have flagged unusual activity associated with your connection. If you believe this is an error, please contact support.",
  [IPQS_COUNTRY_MISMATCH_MESSAGE]:
    "We couldn't verify your location\nIt looks like you're signing in from a different country than usual. To keep your account secure, we've paused this login. If this is really you, please contact support or try again from your usual location.",
};

// Returns the heading+description formatted message when `message` exactly
// matches one of the known IPQS backend messages, otherwise undefined.
export const getIpqsToastMessage = (message?: string): string | undefined => {
  if (!message) {
    return undefined;
  }
  return IPQS_TOAST_MESSAGES[message];
};
